/**
 * 탈퇴 요청 관리 타입 정의
 */
import { formatDateArray } from '../../shared/lib/dateFormatterHelpers';
import { formatCurrency } from '@/shared/utils/formatter';

/** 탈퇴 요청 DTO (백엔드 응답) */
export type WithdrawRequestDto = {
    riderId: string;                       // 라이더 ID
    riderName: string;                     // 라이더명
    suppId: string;                        // 협력사 ID
    suppName: string;                      // 협력사명
    contStatus: string;                    // 계약 상태 코드
    contStatusName: string | null;         // 계약 상태명 (null 가능)
    memberWithdrawalStatusCd: string;      // 탈퇴 요청 상태 코드
    memberWithdrawalStatusCdName: string;  // 탈퇴 요청 상태명
    memberWithdrawalReqDate: number[];      // 탈퇴 요청 일시 [년, 월, 일, 시, 분, 초]
    balAmt: number | null;                 // 잔액 (null 가능)
    unpaidAmt: number | null;              // 미납 금액 (null 가능)
};

/** 탈퇴 요청 목록 조회 응답 DTO */
export type GetWithdrawRequestListResponseDto = {
    withdrawalList: WithdrawRequestDto[];
    totalCount: number;
};

/** 탈퇴 요청 Domain Model */
export type WithdrawRequest = {
    no: number;
    riderId: string;
    riderName: string;
    suppId: string;
    suppName: string;
    contStatus: string;
    contStatusName: string;
    withdrawalStatusCd: string;
    withdrawalStatusCdName: string;
    withdrawalReqDate: string;
    withdrawalReqDateTime: string;
    balAmt: number;
    balAmtFormatted: string;
    unpaidAmt: number;
    unpaidAmtFormatted: string;
};

/** 날짜 배열을 날짜만 문자열로 변환 */
const formatDateOnly = (dateArray: number[] | null): string => {
    if (!dateArray || dateArray.length < 3) return '-';
    const [year, month, day] = dateArray;
    const monthStr = String(month).padStart(2, '0');
    const dayStr = String(day).padStart(2, '0');
    return `${year}-${monthStr}-${dayStr}`;
};

/** 금액 포맷팅 (null은 '-' 반환) */
const formatAmount = (amount: number | null): string => {
    if (amount === null || amount === undefined) return '-';
    return formatCurrency(amount);
};

/** DTO -> Domain 변환 */
export const withdrawRequestFromDto = (
    dto: WithdrawRequestDto,
    index: number
): WithdrawRequest => {
    const withdrawalReqDateTime = formatDateArray(dto.memberWithdrawalReqDate);
    const withdrawalReqDate = formatDateOnly(dto.memberWithdrawalReqDate);

    return {
        no: index + 1,
        riderId: dto.riderId || '',
        riderName: dto.riderName || '',
        suppId: dto.suppId || '',
        suppName: dto.suppName || '',
        contStatus: dto.contStatus || '',
        contStatusName: dto.contStatusName || '',
        withdrawalStatusCd: dto.memberWithdrawalStatusCd || '',
        withdrawalStatusCdName: dto.memberWithdrawalStatusCdName || '',
        withdrawalReqDate,
        withdrawalReqDateTime,
        balAmt: dto.balAmt ?? 0,
        balAmtFormatted: formatAmount(dto.balAmt),
        unpaidAmt: dto.unpaidAmt ?? 0,
        unpaidAmtFormatted: formatAmount(dto.unpaidAmt)
    };
};

/** 목록 변환 */
export const withdrawRequestListFromDto = (
    response: GetWithdrawRequestListResponseDto
): WithdrawRequest[] => {
    if (!response || !response.withdrawalList || !Array.isArray(response.withdrawalList)) {
        return [];
    }
    return response.withdrawalList.map((dto, index) => withdrawRequestFromDto(dto, index));
};

